<template>
    <div class="noticiabackgroundcolor alimentacao">
      
      <div class="extensao_banner">
        <BreadCrumb :breadcrumb="breadcrumb" class="bcp" />
        <h1>SASUMA / {{ $t("UMA_LANG_SASUMA_HOMEMENU_ALIMENTACAO") }}</h1>
      </div>

      <div class="row align-center">
        <div class="small-10 medium-10 large-9 columns bolsaslist">
          <p class="introbolsatexto alimentacaotexto" 
            v-html="$t('UMA_LANG_SASUMA_ALIMENTACAO_TEXTO')"></p>
          <div class="downloaddocuments">
            <a target="_blank" href="https://testuma.sharepoint.com/:b:/s/outrasestruturas/sasuma/areaprivada/alimentacao/EVjdSACz3J9Eh5XXyMzU6pcBWRC9KkCS2kVoI7o-BB46FQ?e=rJnGoc">
                <span class="download_icon_large">
                    <i class="ms-Icon ms-Icon--Download"></i>
                </span>{{ $t("UMA_LANG_SASUMA_ALIMENTACAO_DESCARREGARPRECARIO") }}
            </a>
          </div>
        </div>
      </div>

      <AlimentacaoGrid />

      <div class="row align-center homeEmenta" id="ementa">
        <div class="columns small-12 medium-12 large-9">
          <HomeSectionTitle 
            class="xpto"
            :title="$t('UMA_LANG_SASUMA_HOME_EMENTASEMANAL')" />
          <div id="consultalocalContent">
            <EmentaList />
            <router-link to="/alimentacao" class="morelinks">
                <i class="fa fa-plus-square-o"></i>
                {{ $t("UMA_LANG_SASUMA_VERMAIS") }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="row align-center" id="ementa">
        <div class="columns small-12 medium-12 large-10">
          <HomeSectionTitle 
            :title="$t('UMA_LANG_SASUMA_ALIMENTACAO_RESTAURANTESEHORARIOS')" />
          <RestauranteHorario v-for="restaurante in restaurantes"
              :titulo="restaurante.Titulo"
              :descricao="restaurante.Descricao"
              :horario="restaurante.Horario" />
        </div>
      </div>

    </div>
 <!--
  <div class="noticiabackgroundcolor alimentacao">
        <div class="extensao_banner">
            <?php include(locate_template('template-parts/component-breadcrumb-vue-teste.php')); ?>
            <h1>SASUMA / <?php echo UMA_LANG_SASUMA_HOMEMENU_ALIMENTACAO; ?></h1>
        </div>
        <div class="row align-center">
            <div class="small-10 medium-10 large-9 columns bolsaslist">
                <p class="introbolsatexto alimentacaotexto"><?php echo UMA_LANG_SASUMA_ALIMENTACAO_TEXTO; ?>
                    </p>
                <div class="downloaddocuments">
                    <a target="_blank" href="https://testuma.sharepoint.com/:b:/s/outrasestruturas/sasuma/areaprivada/alimentacao/EVjdSACz3J9Eh5XXyMzU6pcBWRC9KkCS2kVoI7o-BB46FQ?e=rJnGoc">
                        <span class="download_icon_large">
                            <i class="ms-Icon ms-Icon--Download"></i>
                        </span><?php echo UMA_LANG_SASUMA_ALIMENTACAO_DESCARREGARPRECARIO; ?>
                    </a>

                </div>
            </div>
        </div>
        <alimentacaogrid id="algrid" :grid="grid"></alimentacaogrid>
        <div class="row align-center" id="ementa">
            <div class="columns small-12 medium-12 large-10">
                <div class="centerContent">
                    <p class="carouselTitle"><?php echo UMA_LANG_SASUMA_ALIMENTACAO_EMENTASEMANAL; ?></p>
                    <span class="curso_linha3 azul_site_background"></span>
                </div>
                <ementa-list></ementa-list>
            </div>
        </div>
        <div class="row align-center" id="ementa">
            <div class="columns small-12 medium-12 large-10">
                <div class="centerContent">
                    <p class="carouselTitle"><?php echo UMA_LANG_SASUMA_ALIMENTACAO_RESTAURANTESEHORARIOS; ?></p>
                    <span class="curso_linha3 azul_site_background"></span>
                </div>
                <restaurante v-for="restaurante in restaurantes"
                    :titulo="restaurante.Titulo"
                    :descricao="restaurante.Descricao"
                    :horario="restaurante.Horario" />
            </div>
        </div>
    </div>-->
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "@/axios";
import { i18n } from "@/main.js";
import { onBeforeRouteLeave } from 'vue-router';
import BreadCrumb from "@/components/BreadCrumb.vue";
import AlimentacaoGrid from "@/components/AlimentacaoGrid.vue";
import HomeSectionTitle from "@/components/HomeSectionTitle.vue";
import EmentaList from "@/components/Ementa/EmentaList.vue";
import RestauranteHorario from "@/components/RestauranteHorario.vue";

export default {
  components: {
    BreadCrumb,
    AlimentacaoGrid,
    HomeSectionTitle,
    EmentaList,
    RestauranteHorario
  },
  setup () {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";
    
    const breadcrumb = ref([]);
    onMounted(() => {
      breadcrumb.value = [
        { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
        { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
        { ID: 3, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
        { ID: 4, text: t("breadcrumb.sas"), route: { to: "/" } },
        { ID: 5, text: t("breadcrumb.alimentacao"), href: "#" }
      ]
    })

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    const restaurantes = ref([]);

    const getRestaurantes = () => {
      axios.get(`/restaurantes?idioma=${lang}`).
        then(data => {
          restaurantes.value = data.data;
        }).catch(error => {
          console.log(error);
        })
    }

    getRestaurantes()

    return {
      restaurantes,
      breadcrumb
    }
  }
}
</script>

<style>
@media (max-width: 767px) {
  .xpto{
    --carousel-title-padding-top-mobile: 0;
  }
}
</style>

<style lang="scss" scoped>
.extensao_banner h1 {
  text-align: center;
  font-family: "Montserrat Bold";
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0, -10px, 0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}

.bolsaslist {
  padding-right: 0;
  padding-left: 0;
  max-width: 1330px;
}

@media (max-width: 1350px) {
  .bolsaslist {
    padding-right: 0;
    padding-left: 0;
    max-width: 100%;
  }
}

@media (max-width: 1280px) {
  .bolsaslist {
    padding-left: 0;
    padding-right: 0;
  }
}

.introbolsatexto {
  margin-top: 60px;
  margin-left: 10px;
  margin-right: 10px;
  padding-right: 15px;
  padding-left: 50px;
  font-size: 17px;
  font-family: "Montserrat Light";
  line-height: 2.3;
  color: #494d52eb;
  margin-bottom: 90px;
}

.introbolsatexto.alimentacaotexto{
  margin-bottom: 20px;
}


@media (max-width: 1400px) {
  .introbolsatexto {
    margin-left: 0px;
    margin-right: 0px;
    padding-right: 0px;
    padding-left: 0px;
    margin-top: 30px;
  }
}

@media (max-width: 767px) {
  .introbolsatexto {
    font-size: 14px;
    line-height: 2;
    color: #333333;
    margin-top: 0px;
    margin-bottom: 40px;
    padding-top: 15px;
    padding-right: 0px;
    padding-left: 0px;
  }
}


@media (max-width: 767px) {
  .large-9 {
    flex: 0 0 100%;
  }

  .bolsaslist {
    padding-left: 5%;
    padding-right: 5%;
  }
}



.downloaddocuments{
  margin-left: 60px;
  margin-right: 10px;
  font-family: "PT Sans";
  margin-top: 10px;
  margin-bottom: 90px;
}

.downloaddocuments:first-of-type {
  margin-bottom: 0px;
  margin-top: 50px;
}


.downloaddocuments:nth-of-type(2) {
  margin-bottom: 0px;
}

.downloaddocuments:nth-of-type(3) {
  margin-bottom: 0px;
}

.downloaddocuments:last-of-type {
  margin-bottom: 80px!important;
}


.downloaddocuments a:hover {
  font-family: "Montserrat Semibold";
}

@media (max-width: 1400px){
  .downloaddocuments{
    margin-left: 0;
    margin-right: 0;
  }
}

.downloaddocuments.nomargin{
  margin-left: 0;
}

.downloaddocuments a{
  color: #6eb7ec;
  font-family: "Montserrat";
  font-size: 20px;
}

.downloaddocuments i{
  margin-right: 8px;
  font-weight: 600 !important;
  font-size: 20px;
  color: #6eb7ec;
}


@media (max-width: 767px){
  .downloaddocuments a{
    font-size: 14px;
  }
}


.homeEmenta{
  padding-bottom: 85px;
}

.homeEmenta .morelinks{
  color: #6eb7ec;
  text-transform: uppercase;
  display: flex;
  font-size: 15px;
  align-items: center;
}

.morelinks {
    font-size: 15px;
    font-family: 'Montserrat Bold';
    color: white;
}

.morelinks {
    padding-left: 16px;
}

.morelinks i {
    margin-right: 10px;
    font-size: 24px;
}

.morelinks, .morelinks:hover{
  color: #6eb7ec;
  left: 0;
  bottom: 0;
  z-index: 50;
  text-transform: uppercase;
  display: flex;
  font-size: 15px;
  align-items: center;
}

@media (max-width: 767px) {
  .homeEmenta {
    padding-top: 50px;
  }

  .homeEmenta .morelinks{
    margin-top: 30px;
  }
}
</style>